export const legalEn = {
  company: {
    name: 'MULTI SERVICE S.R.L.S.',
    dba: ['SynthoHosting', 'Syntho.Network', 'SynthoNetwork', 'SynthoGuard', 'Minefence', 'Multi Service Società a Responsabilità Limitata Semplificata'],
    address: 'Via Isonzo 102, Racale (LE), 73055, Italy',
    vat: 'IT 05316380756',
    rea: 'LE - 358063',
    phone: '+3909841800706',
    email: 'amministrativo@synthohosting.net',
    website: 'synthohosting.net'
  },
  terms: {
    title: 'Terms of Service',
    lastUpdated: 'Last Updated: March 2024',
    introduction: 'These Legal Terms constitute a legally binding agreement made between you, whether personally or on behalf of an entity ("you"), and MULTI SERVICE S.R.L.S., concerning your access to and use of the Services. You agree that by accessing the Services, you have read, understood, and agreed to be bound by all of these Legal Terms. IF YOU DO NOT AGREE WITH ALL OF THESE LEGAL TERMS, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY.',
    sections: [
      {
        title: '1. Terms of Sale',
        content: 'All SynthoHosting customers are required to adhere to the terms of service. It is the customer\'s responsibility to stay informed about any future changes to them.'
      },
      {
        title: '2. Contract Duration',
        content: 'Customers can terminate SynthoHosting services at any time by informing us through their client area of the intention to cancel the service. However, the contract duration is tied to the billing period, and if the customer decides to terminate before, they will lose the remaining days/months/years, and the payment is non-refundable.'
      },
      {
        title: '3. Provider\'s Responsibility',
        content: 'SynthoHosting assumes no responsibility for any potential damage, whether accidental or consequential. It is the customer\'s responsibility to secure the data hosted on SynthoHosting services in a safe location.'
      },
      {
        title: '4. Payments and Invoices',
        content: 'All SynthoHosting services are billed based on the activation dates. Payments are non-refundable after 74 hours from product activation. Payments can only be made through Stripe, Paypal, or Bank Transfer. Billing occurs only in Monthly, Quarterly, Semi-Annually, Annually, Biennial, and Triennial intervals. SynthoHosting has the right to suspend and/or terminate services for payment disputes. Account balance is not transferable between customers.'
      },
      {
        title: '5. Renewals',
        content: 'After the service expiration date at SynthoHosting, it is possible to renew the service within 5 days; if payment is not made, the service will be deleted after 7 days.'
      },
      {
        title: '6. Termination',
        content: 'To terminate the contract with SynthoHosting, one must access their client area available at my.synthohosting.net and click the cancellation button, specifying the termination date and reason (optional).'
      },
      {
        title: '7. Service Level Agreement (SLA)',
        content: 'Monthly Service-level Agreement guarantees:\n- VPS Services: 95.00%\n- Dedicated Servers: 97.95%\n- Protected Transit: 98.95%\n- Non-Protected Transit: 98.00%\n- All other services: 90.00%\n\nCompensation for SLA violations is provided exclusively as service extension. Customers agree to use services at their own risk, and SynthoHosting is not liable for data loss or other damages.'
      },
      {
        title: '8. Rights',
        content: 'Any illegal material or material violating the rights of third parties hosted on SynthoHosting servers is prohibited. SynthoHosting reserves the right to suspend the service at any time.'
      },
      {
        title: '9. Customer Information',
        content: 'All customers must provide complete and accurate personal data. Any abuse of invented information will result in account suspension. In accordance with Italian Legislative Decree no. 70 of April 9, 2003, MULTI SERVICE S.R.L.S. reserves the right to request identity verification and use third-party platforms for verification.'
      },
      {
        title: '10. Prohibited Content',
        content: 'The following are strictly prohibited:\n- Illegal, harmful, or offensive content\n- Nulled scripts\n- Illegal torrents\n- Public/VPN proxy servers\n- SPAM\n- TOR\n- Phishing pages\n- Slowloris scripts\n- DoS/DDoS activities\n- CPU-intensive scripts (Bitcoin mining, bots)\n- Illegal distribution of copyrighted materials\n- Child pornography\n- CPU usage exceeding 90% continuously'
      },
      {
        title: '11. Fair Usage Policy',
        content: 'Bandwidth is provided on a fair use basis with a 5TB/month threshold. Customers exceeding this limit will be contacted to arrange future bandwidth usage through a BMG quote.'
      },
      {
        title: '12. DDoS Protection',
        content: 'SynthoHosting\'s DDoS protection has been tested with nominal protection up to 88 Tb/s. We guarantee protection up to 4 Tb/s.'
      }
    ]
  },
  privacy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last Updated: March 2024',
    sections: [
      {
        title: '1. Data Collection',
        content: 'We collect personal information necessary for service provision and account management, including name, email, billing information, and service usage data.'
      },
      {
        title: '2. Data Usage',
        content: 'Collected data is used for service delivery, communication, billing, and legal compliance. We do not sell or share personal data except as required for service provision.'
      },
      {
        title: '3. Data Protection',
        content: 'We implement industry-standard security measures including encryption, firewalls, and regular security audits.'
      },
      {
        title: '4. Your Rights',
        content: 'You have the right to access, correct, or delete your personal data. Contact our support team to exercise these rights.'
      }
    ]
  },
  cookies: {
    title: 'Cookie Policy',
    lastUpdated: 'Last Updated: March 2024',
    sections: [
      {
        title: '1. What Are Cookies',
        content: 'Cookies are small text files stored on your device to enhance website functionality and user experience.'
      },
      {
        title: '2. Cookie Types',
        content: 'We use essential cookies for basic functionality and analytical cookies to improve our services. Third-party cookies may be used for analytics and marketing.'
      },
      {
        title: '3. Cookie Control',
        content: 'You can control cookie preferences through your browser settings. Note that disabling certain cookies may affect website functionality.'
      }
    ]
  }
}